import AOS from 'aos';
import 'aos/dist/aos.css';
import isCurrentMq from './isCurrentMq.js';

/**
 * aos.js初期化
 */
const initAOS = () => {
    const mq = isCurrentMq();

    // 発火位置の設定
    let offset = 100; //SP
    if (mq === 'md-header' || mq === 'lg' || mq === 'xl') {
        offset = -100; //PC
    }

    AOS.init({
        offset: offset,
        once: true,
        delay: 0,
        duration: 700,
    });
}

export default initAOS